<kendo-stepper
  [steps]="steps"
  [(currentStep)]="currentStep"
  [stepType]="stepType"
  [linear]="false"
  successIcon="k-icon k-i-check-circle"
  errorIcon="k-icon k-i-close-outline"
  >
  <ng-template kendoStepperLabelTemplate let-step>
    @if (currentStep === step.stepNumber) {
      <span>{{ step.label }}</span>
    }
  </ng-template>
</kendo-stepper>
